import { ESTATE_ITEM_GROUPS, GROUP_OF_TYPE, OTHER_GROUP } from "./estateItemGroups";

// The staff app sends the deceased's percentage share as a decimal string; without a readable one
// we take the whole item, as EstateItem.ownership_share's column default does
export const ownershipShare = (item) => {
  const share = parseFloat(item.ownership_share);
  return Number.isFinite(share) ? share : 100;
};

// The staff app sends each item's whole value. Rounds half away from zero to the penny, as
// EstateItem.share_adjusted's ROUND_HALF_UP does.
export const clientShareOfPence = (item) => {
  if (item.amount_pence == null) {
    return null;
  }
  const share = (item.amount_pence * ownershipShare(item)) / 100;
  return Math.sign(share) * Math.round(Math.abs(share));
};

const pounds = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" });

// Intl writes a hyphen for a negative amount; the ledger uses a minus sign throughout
export const formatPence = (pence) => `${pence < 0 ? "−" : ""}${pounds.format(Math.abs(pence) / 100)}`;

// The staff app sends each item's signed contribution to current_net_distributable_pence, or null
// when it has no figure; a ledger sent before counts_in_totals existed counts every item
export const distributableTotal = (items) => {
  const counted = items.filter((item) => item.counts_in_totals !== false);
  if (counted.length === 0) {
    return 0;
  }
  const figures = counted.map((item) => item.distributable_contribution_pence).filter((pence) => pence != null);
  return figures.length === 0 ? null : figures.reduce((total, pence) => total + pence, 0);
};

const liveItems = (ledger) => (ledger?.items ?? []).filter((item) => item.progress !== "ruled_out");

export const itemsOfTypes = (ledger, types) => liveItems(ledger).filter((item) => types.includes(item.item_type));

export const groupLedger = (ledger) => {
  const items = liveItems(ledger);

  const groupsFor = (direction) => {
    const ofDirection = items.filter((item) => item.direction === direction);
    const groupOf = (item) => GROUP_OF_TYPE[item.item_type] ?? OTHER_GROUP[direction];

    return ESTATE_ITEM_GROUPS[direction]
      .map((group) => ({ ...group, items: ofDirection.filter((item) => groupOf(item) === group.key) }))
      .filter((group) => group.items.length > 0);
  };

  return { asset: groupsFor("asset"), liability: groupsFor("liability") };
};
